export default __webpack_public_path__ + "static/media/4.9d8d2f5f.png";